// Keep the installation's head intact; account branding is a reversible overlay.
export const createAccountBrandingSwitcher = () => {
  let originals = [];
  let added = [];

  const restore = () => {
    originals.forEach(({ element, attributes }) => {
      ['href', 'content', 'data-default-icon', 'data-badge-icon'].forEach(
        name => {
          const value = attributes[name];
          if (value === null) element.removeAttribute(name);
          else element.setAttribute(name, value);
        }
      );
    });
    added.forEach(element => element.remove());
    originals = [];
    added = [];
  };

  const remember = element => {
    originals.push({
      element,
      attributes: Object.fromEntries(
        ['href', 'content', 'data-default-icon', 'data-badge-icon'].map(
          name => [name, element.getAttribute(name)]
        )
      ),
    });
  };

  const ensure = (selector, tag, attributes) => {
    const existing = document.head.querySelector(selector);
    if (existing) return existing;
    const element = document.createElement(tag);
    Object.entries(attributes).forEach(([name, value]) =>
      element.setAttribute(name, value)
    );
    document.head.appendChild(element);
    added.push(element);
    return element;
  };

  const apply = branding => {
    restore();
    if (!branding?.faviconBase) return;
    const base = branding.faviconBase;
    document.head
      .querySelectorAll(
        'link[rel~="icon"], link[rel="apple-touch-icon"], link[rel="manifest"], meta[name="theme-color"]'
      )
      .forEach(remember);

    [16, 32, 96].forEach(size =>
      ensure(`link.favicon[sizes="${size}x${size}"]`, 'link', {
        class: 'favicon',
        rel: 'icon',
        type: 'image/png',
        sizes: `${size}x${size}`,
      })
    );
    document.head.querySelectorAll('link[rel~="icon"]').forEach(icon => {
      const requestedSize = Number(icon.getAttribute('sizes')?.split('x')[0]);
      const size = [16, 32, 48, 96, 180, 192, 512].includes(requestedSize)
        ? requestedSize
        : 32;
      icon.href = `${base}/favicon-${size}x${size}.png?v=2`;
      if (icon.classList.contains('favicon')) {
        icon.dataset.defaultIcon = icon.getAttribute('href');
        const badgeSize = [16, 32, 96].includes(size) ? size : 32;
        icon.dataset.badgeIcon = `${base}/favicon-badge-${badgeSize}x${badgeSize}.png?v=2`;
      }
    });
    ensure('link[rel="apple-touch-icon"]', 'link', {
      rel: 'apple-touch-icon',
      sizes: '180x180',
    });
    document.head
      .querySelectorAll('link[rel="apple-touch-icon"]')
      .forEach(icon => {
        icon.href = `${base}/favicon-180x180.png?v=2`;
      });
    ensure('link[rel="manifest"]', 'link', { rel: 'manifest' }).href =
      `${base}/manifest.json?v=2`;
    ensure('meta[name="theme-color"]', 'meta', {
      name: 'theme-color',
    }).content = branding.themeColor;
  };

  return { apply, restore };
};
